var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"logoHolder"},[_c('img',{attrs:{"src":require('@/assets/icons/' + _vm.icon)}})])}
var staticRenderFns = []

export { render, staticRenderFns }